import { SHORT_SEPARATOR_POSITIONS as g, LONG_SEPARATOR_POSITIONS as f } from "./index.es652.js";

var O = function O(l, n, o) {
  var _l$current, _l$current2;

  var s = ((_l$current = l.current) === null || _l$current === void 0 ? void 0 : _l$current.selectionStart) || 0,
      h = ((_l$current2 = l.current) === null || _l$current2 === void 0 ? void 0 : _l$current2.selectionEnd) || 0,
      c = s === h,
      d = n.length > o.length,
      t = n.length < o.length,
      i = t && c,
      a = d && c && g.includes(s),
      e = d && c && f.includes(s - 2),
      A = i && g.includes(s),
      S = i && g.includes(s - 1),
      r = i && f.includes(s),
      u = i && f.includes(s - 1);
  return {
    selectionStart: s,
    selectionEnd: h,
    isSingleCursor: c,
    isCharactersDeleted: d,
    isCharactersAdded: t,
    isDeleteSingleDash: a,
    isDeleteSingleLongDash: e,
    isAddLastRemainCharBeforeDash: A,
    isAddNewCharBeforeDash: S,
    isAddLastRemainCharBeforeLongDash: r,
    isAddNewCharBeforeLongDash: u
  };
},
    L = function L(_ref, e) {
  var l = _ref.isDeleteSingleDash,
      n = _ref.selectionStart,
      o = _ref.isAddLastRemainCharBeforeDash,
      s = _ref.isAddNewCharBeforeDash,
      h = _ref.isCharactersDeleted,
      c = _ref.isCharactersAdded,
      d = _ref.selectionEnd,
      t = _ref.isAddLastRemainCharBeforeLongDash,
      i = _ref.isAddNewCharBeforeLongDash,
      a = _ref.isDeleteSingleLongDash;
  a ? e(n - 3) : l ? e(n - 1) : t || i ? e(n + 3) : s || o ? e(n + 1) : h ? e(n) : c && e(d);
};

export { L as applyCaretPosition, O as inputPositionStats };